<template>
  <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 4C0 1.79086 1.79086 0 4 0H24V32H4C1.79086 32 0 30.2091 0 28V4Z" fill="#F9F9F9"/>
<path d="M15.334 12.666H13.334C12.9673 12.666 12.6673 12.966 12.6673 13.3327C12.6673 13.6993 12.9673 13.9993 13.334 13.9993H15.334C16.434 13.9993 17.334 14.8993 17.334 15.9993C17.334 17.0993 16.434 17.9993 15.334 17.9993H13.334C12.9673 17.9993 12.6673 18.2993 12.6673 18.666C12.6673 19.0327 12.9673 19.3327 13.334 19.3327H15.334C17.174 19.3327 18.6673 17.8393 18.6673 15.9993C18.6673 14.1593 17.174 12.666 15.334 12.666ZM9.33398 15.9993C9.33398 16.366 9.63398 16.666 10.0007 16.666H14.0007C14.3673 16.666 14.6673 16.366 14.6673 15.9993C14.6673 15.6327 14.3673 15.3327 14.0007 15.3327H10.0007C9.63398 15.3327 9.33398 15.6327 9.33398 15.9993ZM10.6673 17.9993H8.66732C7.56732 17.9993 6.66732 17.0993 6.66732 15.9993C6.66732 14.8993 7.56732 13.9993 8.66732 13.9993H10.6673C11.034 13.9993 11.334 13.6993 11.334 13.3327C11.334 12.966 11.034 12.666 10.6673 12.666H8.66732C6.82732 12.666 5.33398 14.1593 5.33398 15.9993C5.33398 17.8393 6.82732 19.3327 8.66732 19.3327H10.6673C11.034 19.3327 11.334 19.0327 11.334 18.666C11.334 18.2993 11.034 17.9993 10.6673 17.9993Z" fill="#8DA0A9"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>